import { render, staticRenderFns } from "./PendingAppointmentsDesktop.vue?vue&type=template&id=868e3c7c&"
import script from "./PendingAppointmentsDesktop.vue?vue&type=script&lang=js&"
export * from "./PendingAppointmentsDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports